import { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { EnvelopeIcon, CogIcon, ArrowRightOnRectangleIcon } from '@heroicons/react/24/outline'
import EmailModal from './EmailModal'

interface HeaderProps {
  selectedTemplates: number[]
  setSelectedTemplates: (templates: number[]) => void
}

export default function Header({ selectedTemplates }: HeaderProps) {
  const [showEmailModal, setShowEmailModal] = useState(false)
  const navigate = useNavigate()
  const isAdmin = localStorage.getItem('admin_token') !== null

  const handleLogout = () => {
    localStorage.removeItem('admin_token')
    navigate('/')
  }

  return (
    <>
      <header className="bg-white shadow-sm border-b relative z-30">
        <div className="container mx-auto px-4">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center space-x-8">
              <div className="flex items-center space-x-3 text-2xl font-bold">
                <a 
                  href="https://stripo.email" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-primary-500 hover:text-primary-600 transition-colors"
                >
                  <img 
                    src="/stripo-logo.svg" 
                    alt="Stripo Logo" 
                    className="h-12 w-auto"
                    style={{ display: 'block' }}
                  />
                </a>
                <Link 
                  to="/" 
                  className="font-semibold text-primary-500 hover:text-primary-600 transition-colors"
                >
                  Showcase
                </Link>
              </div>
            </div>

            <div className="flex items-center space-x-4">
              {selectedTemplates.length > 0 && (
                <button
                  onClick={() => setShowEmailModal(true)}
                  className="flex items-center space-x-2 bg-primary-500 text-white px-4 py-2 rounded-lg hover:bg-primary-600 transition-colors"
                >
                  <EnvelopeIcon className="w-5 h-5" />
                  <span>Send ({selectedTemplates.length})</span>
                </button>
              )}
              
              {isAdmin ? (
                <>
                  <Link
                    to="/admin"
                    className="p-2 text-gray-600 hover:text-primary-600 transition-colors"
                  >
                    <CogIcon className="w-6 h-6" />
                  </Link>
                  <button
                    onClick={handleLogout}
                    className="flex items-center space-x-2 px-3 py-2 text-gray-600 hover:text-red-600 transition-colors"
                    title="Logout"
                  >
                    <ArrowRightOnRectangleIcon className="w-5 h-5" />
                  </button>
                </>
              ) : (
                <Link
                  to="/admin/login"
                  className="flex items-center space-x-2 px-4 py-2 text-gray-600 hover:text-primary-600 transition-colors"
                >
                  <CogIcon className="w-5 h-5" />
                  <span className="hidden md:inline">Admin</span>
                </Link>
              )}
            </div>
          </div>
        </div>
      </header>

      {showEmailModal && (
        <EmailModal
          templateIds={selectedTemplates}
          onClose={() => setShowEmailModal(false)}
        />
      )}
    </>
  )
}
